const ErrorPage = () => {
  return <div>An error occurred during authentication</div>;
};

export default ErrorPage;
